import { render } from "./AppRadioButton.vue?vue&type=template&id=4a64bfff&scoped=true&ts=true"
import script from "./AppRadioButton.vue?vue&type=script&lang=ts"
export * from "./AppRadioButton.vue?vue&type=script&lang=ts"

import "./AppRadioButton.vue?vue&type=style&index=0&id=4a64bfff&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a64bfff"]])

export default __exports__